<h2>
  <b>{{ title | translate }}</b>
</h2>

<ng-template #viewContainerRef></ng-template>
